import _ from 'underscore';

export default function mapToObject(list, iteratee) {
  return _.object(list, _.map(list, iteratee));
}
